import _ from 'lodash';
import toposort from 'assets/js/toposort';

// MainMenuSidebar is the static main menu object that is displayed by default
// in the QReserve app.
export const MainMenuSidebar = {
  site: [
    {
      section: 'reports',
      role: ['moderator', 'administrator'],
      main: {
        name: 'reports',
        icons: [
          {
            iconName: 'faChartLine',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) => `/admin/sites/${selected.site_id}/reports`,
        show: (obj) => obj.appviewSidebar.site.reports.show,
        text: 'Reports',
      },
      children: [
        {
          name: 'usage',
          icons: [
            {
              iconName: 'faUserClock',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) => `/admin/sites/${selected.site_id}/reports/usage`,
          show: (obj) => obj.appviewSidebar.site.reports.usage &&
            obj.$route.meta.mainMenuRoot === 'reports',
          text: 'Activity',
        },
        {
          name: 'actualusage',
          icons: [
            {
              iconName: 'faWatch',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) =>
            `/admin/sites/${selected.site_id}/reports/actualusage`,
          show: (obj) => obj.appviewSidebar.site.reports.actual_usage &&
            obj.selected &&
            obj.selected.plan &&
            obj.selected.plan.actual_usage &&
            obj.$route.meta.mainMenuRoot === 'reports',
          text: 'Actual Usage',
        },
        {
          name: 'heatmaps',
          icons: [
            {
              iconName: 'faThSolid',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) =>
            `/admin/sites/${selected.site_id}/reports/heatmaps`,
          show: (obj) => obj.appviewSidebar.site.reports.heatmaps &&
            obj.$route.meta.mainMenuRoot === 'reports',
          text: 'Heatmaps',
        },
        {
          name: 'capacity',
          icons: [
            {
              iconName: 'faBatteryFull',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) =>
            `/admin/sites/${selected.site_id}/reports/capacity`,
          show: (obj) => obj.appviewSidebar.site.reports.capacity &&
            obj.$route.meta.mainMenuRoot === 'reports',
          text: 'Capacity',
        },
        {
          name: 'custom_reports',
          icons: [
            {
              iconName: 'faFile',
              iconClasses: ['fa-icon-sz-sm'],
              transform: 'grow-1',
            },
            {
              iconName: 'faCog',
              iconClasses: ['cog-report'],
              transform: 'shrink-5',
            },
          ],
          path: (selected) => `/admin/sites/${selected.site_id}/reports/custom`,
          show: (obj) => obj.appviewSidebar.site.reports.custom_reports &&
            obj.$route.meta.mainMenuRoot === 'reports',
          text: 'Custom',
        },
        {
          name: 'audit_log',
          role: ['administrator'],
          icons: [
            {
              iconName: 'faListAlt',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) =>
            `/admin/sites/${selected.site_id}/reports/auditlog`,
          show: (obj) => obj.appviewSidebar.site.reports.audit_log &&
            obj.selected &&
            obj.selected.plan &&
            obj.selected.plan.audit_log &&
            obj.$route.meta.mainMenuRoot === 'reports',
          text: 'Audit Log',
        },
      ],
    },
    {
      section: 'users',
      role: ['moderator', 'administrator'],
      main: {
        name: 'users',
        icons: [
          {
            iconName: 'faUsers',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) => `/admin/sites/${selected.site_id}/users`,
        show: (obj) => obj.appviewSidebar.site.users.show,
        text: 'Users',
      },
      children: [
        {
          name: 'massmessaging',
          icons: [
            {
              iconName: 'faEnvelope',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) => `/admin/sites/${selected.site_id}/messaging`,
          show: (obj) => obj.selected &&
            obj.selected.plan &&
            obj.selected.plan.mass_email &&
            obj.$route.meta.mainMenuRoot === 'users',
          text: 'Messaging',
        },
        {
          name: 'training',
          icons: [
            {
              iconName: 'faUserGraduate',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) =>
            `/admin/sites/${selected.site_id}/training`,
          show: (obj) => obj.selected &&
            obj.selected.plan &&
            obj.selected.plan.training_module &&
            obj.$route.meta.mainMenuRoot === 'users',
          text: 'Credentials',
        },
        {
          name: 'accounts',
          icons: [
            {
              iconName: 'faWallet',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) => `/admin/sites/${selected.site_id}/useraccounts`,
          show: (obj) => obj.selected &&
            obj.selected.plan &&
            obj.selected.plan.accounts_users &&
            obj.$route.meta.mainMenuRoot === 'users',
          text: 'Accounts',
        },
      ],
    },
    {
      section: 'resources',
      role: ['moderator', 'administrator'],
      main: {
        name: 'resources',
        icons: [
          {
            iconName: 'faListAlt',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) => `/admin/sites/${selected.site_id}/resources`,
        show: (obj) => obj.appviewSidebar.site.resources.show,
        text: 'Resources',
      },
      children: [
        {
          name: 'resourcerates',
          icons: [
            {
              iconName: 'faCreditCard',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) =>
            `/admin/sites/${selected.site_id}/resources/rates`,
          show: (obj) => obj.selected &&
            obj.appviewSidebar.site.resources.rates &&
            obj.$route.meta.mainMenuRoot === 'resources',
          text: 'Rates',
        },
        {
          name: 'resourcescripts',
          icons: [
            {
              iconName: 'faCodeBranch',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) =>
            `/admin/sites/${selected.site_id}/resources/scripts`,
          show: (obj) => obj.selected &&
            obj.appviewSidebar.site.resources.scripts &&
            obj.$route.meta.mainMenuRoot === 'resources',
          text: 'Scripts',
        },
      ],
    },
    {
      section: 'external_submissions',
      role: ['moderator', 'administrator'],
      main: {
        name: 'external_submissions',
        icons: [
          {
            iconName: 'faPaintBrush',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) =>
          `/admin/sites/${selected.site_id}/externalsubmissions`,
        show: (obj) => obj.selected &&
          obj.selected.plan.external_submissions &&
          ['administrator'].indexOf(obj.selected.role) !== -1,
        text: 'Submissions',
      },
    },
    {
      section: 'invoices',
      role: ['moderator', 'administrator'],
      main: {
        name: 'invoices',
        icons: [
          {
            iconName: 'faFileInvoiceDollar',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) => `/admin/sites/${selected.site_id}/invoices`,
        show: (obj) => obj.appviewSidebar.site.invoices.show &&
          obj.selected.plan.invoices,
        text: 'Invoices',
      },
      children: [
        {
          name: 'site-payments',
          icons: [
            {
              iconName: 'faCreditCard',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) => `/admin/sites/${selected.site_id}/payments`,
          show: (obj) => obj.selected &&
            obj.selected.plan &&
            obj.selected.plan.invoices &&
            obj.$route.meta.mainMenuRoot === 'invoices',
          text: 'Payments',
        },
      ],
    },
    {
      section: 'forms',
      role: ['administrator', 'moderator'],
      main: {
        name: 'forms',
        icons: [
          {
            iconName: 'faClipboardList',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) => `/admin/sites/${selected.site_id}/forms`,
        show: (obj) => obj.appviewSidebar.site.forms.show,
        text: 'Forms',
        children: [],
      },
    },
    {
      section: 'projects',
      role: ['administrator', 'moderator'],
      main: {
        name: 'projects',
        icons: [
          {
            iconName: 'faUsersClass',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        show: (obj) => obj.appviewSidebar.site.projects.show &&
          obj.selected.plan.projects,
        path: (selected) => `/admin/sites/${selected.site_id}/projects`,
        text: 'Projects',
      },
      children: [],
    },
    {
      section: 'live_maps',
      role: ['moderator', 'administrator'],
      main: {
        name: 'live_maps',
        icons: [
          {
            iconName: 'faMapMarkedAlt',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) =>
          `/admin/sites/${selected.site_id}/resourceavailabilitymaps`,
        show: (obj) => obj.appviewSidebar.site.livemaps.show,
        text: 'Live Maps',
      },
      children: [],
    },
    {
      section: 'kiosks',
      role: ['moderator', 'administrator'],
      main: {
        name: 'kiosks',
        icons: [
          {
            iconName: 'faTablet',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) => `/admin/sites/${selected.site_id}/kiosks`,
        show: (obj) => obj.selected && obj.selected.plan.kiosk,
        text: 'Kiosks',
      },
    },
    {
      section: 'web_integration',
      role: ['moderator', 'administrator'],
      main: {
        name: 'web_integration',
        icons: [
          {
            iconName: 'faCode',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) => `/admin/sites/${selected.site_id}/webintegration`,
        show: (obj) => obj.selected && obj.selected.plan.advanced_web,
        text: 'Web Integration',
      },
    },
    {
      section: 'workflows',
      role: ['moderator', 'administrator'],
      main: {
        name: 'workflows',
        icons: [
          {
            iconName: 'faTasks',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        show: (obj) => obj.appviewSidebar.site.workflows.show &&
          obj.selected.plan.subscriptions,
        path: (selected) => `/admin/sites/${selected.site_id}/subscriptions`,
        text: 'Workflows',
      },
      children: [
        {
          name: 'subscriptions',
          icons: [
            {
              iconName: 'faRepeatSolid',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          show: (obj) =>
            obj.appviewSidebar.site.workflows.subscriptions &&
            obj.selected &&
            obj.selected.plan &&
            obj.selected.plan.subscriptions &&
            obj.$route.meta.mainMenuRoot === 'workflows',
          path: (selected) => `/admin/sites/${selected.site_id}/subscriptions`,
          text: 'Subscriptions',
        },
        {
          name: 'triggers',
          icons: [
            {
              iconName: 'faSensorOn',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          show: (obj) =>
            obj.appviewSidebar.site.workflows.triggers &&
            obj.selected &&
            obj.selected.plan &&
            obj.selected.plan.subscriptions &&
            obj.$route.meta.mainMenuRoot === 'workflows',
          path: (selected) => `/admin/sites/${selected.site_id}/triggers`,
          text: 'Triggers',
        },
      ],
    },
    {
      section: 'settings',
      role: ['administrator'],
      main: {
        name: 'settings',
        icons: [
          {
            iconName: 'faCogs',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) => `/admin/sites/${selected.site_id}/settings`,
        show: (obj) => obj.appviewSidebar.site.settings.show,
        text: 'Site Settings',
      },
      children: [],
    },
  ],
  portal: [
    {
      section: 'dashboard',
      role: ['administrator'],
      main: {
        name: 'dashboard',
        icons: [
          {
            iconName: 'faHome',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) => `/admin/portals/${selected.portal_id}/dashboard`,
        show: (obj) => obj.appviewSidebar.portal.dashboard.show,
        text: 'Dashboard',
        children: [],
      },
    },
    {
      section: 'reports',
      role: ['administrator'],
      main: {
        name: 'reports',
        icons: [
          {
            iconName: 'faChartLine',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) =>
          `/admin/portals/${selected.portal_id}/reports/custom`,
        show: (obj) => obj.appviewSidebar.portal.reports.show,
        text: 'Reports',
      },
      children: [
        {
          name: 'custom_reports',
          icons: [
            {
              iconName: 'faFile',
              iconClasses: ['fa-icon-sz-sm'],
              transform: 'grow-1',
            },
            {
              iconName: 'faCog',
              iconClasses: ['cog-report'],
              transform: 'shrink-5',
            },
          ],
          path: (selected) =>
            `/admin/portals/${selected.portal_id}/reports/custom`,
          show: (obj) => obj.appviewSidebar.portal.reports.custom_reports &&
            obj.$route.meta.mainMenuRoot === 'reports',
          text: 'Custom',
        },
        {
          name: 'audit_log',
          role: ['administrator'],
          icons: [
            {
              iconName: 'faListAlt',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) =>
            `/admin/portals/${selected.portal_id}/reports/auditlog`,
          show: (obj) => obj.appviewSidebar.portal.reports.custom_reports &&
            obj.$route.meta.mainMenuRoot === 'reports',
          text: 'Audit Log',
        },
      ],
    },
    {
      section: 'users',
      role: ['administrator'],
      main: {
        name: 'users',
        icons: [
          {
            iconName: 'faUsers',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) =>
          `/admin/portals/${selected.portal_id}/users`,
        show: (obj) => obj.appviewSidebar.portal.users.show,
        text: 'Users',
      },
      children: [
        {
          name: 'accounts',
          icons: [
            {
              iconName: 'faWallet',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) =>
            `/admin/portals/${selected.portal_id}/useraccounts`,
          show: (obj) => obj.appviewSidebar.portal.users.accounts &&
            obj.$route.meta.mainMenuRoot === 'users',
          text: 'Accounts',
        },
        {
          name: 'training',
          icons: [
            {
              iconName: 'faUserGraduate',
              iconClasses: ['fa-icon-sz-sm'],
              transform: '',
            },
          ],
          path: (selected) =>
            `/admin/portals/${selected.portal_id}/training`,
          show: (obj) => obj.appviewSidebar.portal.users.training &&
            obj.$route.meta.mainMenuRoot === 'users',
          text: 'Credentials',
        },
      ],
    },
    {
      section: 'resources',
      role: ['administrator'],
      main: {
        name: 'resources',
        icons: [
          {
            iconName: 'faListAlt',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) =>
          `/admin/portals/${selected.portal_id}/resources`,
        show: (obj) => obj.appviewSidebar.portal.resources.show,
        text: 'Resources',
      },
      children: [],
    },
    {
      section: 'sites',
      role: ['administrator'],
      main: {
        name: 'sites',
        icons: [
          {
            iconName: 'faSitemap',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) =>
          `/admin/portals/${selected.portal_id}/sites`,
        show: (obj) => obj.appviewSidebar.portal.sites.show,
        text: 'Sites',
      },
      children: [],
    },
    {
      section: 'projects',
      role: ['administrator'],
      main: {
        name: 'projects',
        icons: [
          {
            iconName: 'faUsersClass',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) =>
          `/admin/portals/${selected.portal_id}/projects`,
        show: (obj) => obj.appviewSidebar.portal.projects.show,
        text: 'Projects',
      },
      children: [],
    },
    {
      section: 'forms',
      role: ['administrator'],
      main: {
        name: 'forms',
        icons: [
          {
            iconName: 'faClipboardList',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) => `/admin/portals/${selected.portal_id}/forms`,
        show: (obj) => obj.appviewSidebar.portal.forms.show,
        text: 'Forms',
        children: [],
      },
    },
    {
      section: 'web_integration',
      role: ['administrator'],
      main: {
        name: 'web_integration',
        icons: [
          {
            iconName: 'faCode',
            iconClasses: ['fa-icon-sz-sm'],
            transform: '',
          },
        ],
        path: (selected) =>
          `/admin/portals/${selected.portal_id}/webintegration`,
        text: 'Web Integration',
        show: (obj) => obj.appviewSidebar.portal.web_integration.show,
        children: [],
      },
    },
    {
      section: 'settings',
      role: ['administrator'],
      main: {
        name: 'settings',
        icons: [
          {
            iconName: 'faCogs',
            iconClasses: ['fa-icon-sz'],
            transform: '',
          },
        ],
        path: (selected) =>
          `/admin/portals/${selected.portal_id}/settings`,
        show: (obj) => obj.appviewSidebar.portal.settings.show,
        text: 'Settings',
      },
      children: [],
    },
  ],
};

// reduceSidebarItemsToEdges create edges for a topological graph to sort.
// Edges are declared as such: [ 'node', 'requires_node' ]. isSubItem indicates
// whether or not the items being reduced are in the main menu or a submenu.
const reduceSidebarItemsToEdges = (itemsDefault, itemsCustom, isSubItem) => {
  const firstNameDefault = _.get(itemsDefault[0], 'name');
  const sidebarMenuItemNames = _.concat(
    _.slice(
      _.reduce(itemsDefault,
        (sum, val) => {
          const sumLength = _.size(sum);
          let previousArrItem = null;
          if (sumLength > 0) {
            previousArrItem = sum[sumLength - 1][0];
          }

          // Sub-menu items don't need to reference the nested 'main' item,
          // since it's declared directly.
          sum.push([isSubItem ? val.name : val.main.name, previousArrItem]);
          return sum;
        },
        []),
      1),
    _.map(itemsCustom,
      // Ensure that any dependencies that were custom declared and for which
      // 'inject_after' is set to null are situated to simply inject as the
      // first item in the list.
      (val) => [val.name, val.inject_after ?
        val.inject_after :
        firstNameDefault]),
  );

  return sidebarMenuItemNames;
};

// convertCustomItemsToSideBarItems converts items in the custom syntax form
// from the backend through appview into useable frontend menu items.
const convertCustomItemsToSideBarItems = (sidebarType, itemsCustom) => {
  const routeStr = sidebarType === 'site' ? 'sites' : 'portals';
  return _.map(itemsCustom, (val) => Object({
    section: val.name,
    role: val.role,
    main: {
      name: val.name,
      icons: val.icons,
      path: (selected) =>
        `/admin/${routeStr}/${selected.site_id}/${val.path}`,
      show: () => true,
      text: val.text,
    },
    children: _.map(val.children, (valChild) => Object({
      section: valChild.name,
      role: val.role,
      main: {
        name: valChild.name,
        icons: valChild.icons,
        path: (selected) =>
          `/admin/${routeStr}/${selected.site_id}/${valChild.path}`,
        show: () => true,
        text: valChild.text,
      },
    })),
  }));
};

// convertCustomChildItemsToSideBarItems converts items in the custom child
// syntax form from the backend through appview into useable frontend menu
// items. The main difference with this and the previous function is that
// this function works on nested child items injected into default main
// side menu item buttons as submenu items.
const convertCustomChildItemsToSideBarItems = (sidebarType, name, subItems) => {
  const routeStr = sidebarType === 'site' ? 'sites' : 'portals';
  return _.map(subItems, (val) => Object({
    name: val.name,
    icons: val.icons,
    path: (selected) =>
      `/admin/${routeStr}/${selected.site_id}/${val.path}`,
    show: (obj) => obj.$route.meta.mainMenuRoot === name,
    text: val.text,
  }));
};

// InjectCustomMenuItems is the main work horse for constructing a dynamic
// application view from the default set of sidebar items and custom
// specifications declared in the appview given in the backend. It will
// examine an appview's custom fields and construct new sidebar objects from
// it, then inject them in the order specified by the user.
export const InjectCustomMenuItems = (appview) => {
  const sideBarInjected = {};
  _.forEach(['site', 'portal'], (sidebarType) => {
    // Obtain edges for topological sort.
    const sidebarMenuItemNameEdges = reduceSidebarItemsToEdges(
      _.cloneDeep(MainMenuSidebar[sidebarType]),
      _.get(appview, `sidebar.admin.${sidebarType}.custom`, []),
    );

    // Topologically sort the menu based on the custom element dependencies as
    // given in the graph.
    const sidebarMenuItemNamesSorted = _.reverse(
      toposort(sidebarMenuItemNameEdges));

    // Construct javascript objects for sidemenu items from the appview custom
    // items.
    const customRootMenuItems = convertCustomItemsToSideBarItems(sidebarType,
      _.get(appview, `sidebar.admin.${sidebarType}.custom`, []));

    // Construct a new mapping of sidebar items including the custom items.
    const itemsAsObj = _.fromPairs(
      _.map(
        _.concat(
          _.cloneDeep(MainMenuSidebar[sidebarType]),
          customRootMenuItems),
        (item) => [item.section, item]));

    const sideBarItemsSorted = _.map(sidebarMenuItemNamesSorted,
      (name) => itemsAsObj[name]);

    // Search for custom submenu items for each of the sidebar items in appview.
    // If we have any custom sidebar items, topologically sort and inject them
    // as we did with the main sections/items.
    _.forEach(_.get(appview, `sidebar.admin.${sidebarType}`), (val, key) => {
      // Continue here, since we already parsed custom.
      if (key === 'custom') return true;

      const sideBarItem = _.find(sideBarItemsSorted, (itm) =>
        itm.section === key);
      if (!_.isUndefined(sideBarItem) && _.size(_.get(val, 'custom')) > 0) {
        // Obtain edges for topological sort.
        const subMenuItemNameEdges = reduceSidebarItemsToEdges(
          sideBarItem.children, val.custom, true);

        // Topologically sort the menu based on the custom element
        // dependencies as given in the graph.
        const submenuMenuItemNamesSorted = _.reverse(
          toposort(subMenuItemNameEdges));

        // Construct javascript objects for submenu items from the appview
        // custom items.
        const customSideMenuItems = convertCustomChildItemsToSideBarItems(
          sidebarType, key, val.custom);

        // Construct a new mapping of submenu sidebar items including the custom
        // items.
        const itemsSubAsObj = _.fromPairs(
          _.map(_.concat(sideBarItem.children, customSideMenuItems),
            (item) => [item.name, item]));

        // Construct a new, sorted array of items.
        const submenuItemsSorted = _.map(submenuMenuItemNamesSorted,
          (name) => itemsSubAsObj[name]);
        _.set(sideBarItem, 'children', submenuItemsSorted);
      }

      return true;
    });

    sideBarInjected[sidebarType] = sideBarItemsSorted;
  });

  return sideBarInjected;
};

export const RecommendContacts = [
  { name: 'Dominique', email: 'dominique.krawchenko@qreserve.com' },
  { name: 'Milica', email: 'milica.vrakela@qreserve.com' },
];
